import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import MachinesGroupsApi from '@/services/apiServiceModules/machinesGroupsApi.js'
const machinesGroupsApi = new MachinesGroupsApi()

export default class MachinesGroupsDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.MACHINES_GROUPS, machinesGroupsApi, {
			useCache: true,
		})
	}
}
